<script>
    import { createEventDispatcher } from 'svelte';
    import IconDel from "../icons/IconDel.svelte";
    import IconEdit from '../icons/IconEdit.svelte';

    export let location = {id: 0, name: '', description: '', levels: 0, levelPositions: 0};

    const dispatch = createEventDispatcher();

    function editLocation(editedLocation) {
        let editedLocationItem = editedLocation.detail.item;
        dispatch('editLocation', {
            editedLocationItem
        });
    }
</script>

<div class="box">
    <div class="icons">
        <IconEdit item={location} on:clicked={(editedLocation) => editLocation(editedLocation)}/>
    </div>
    <div class="content">{location.name}&nbsp;{location.description}</div>
    <div class="contentDetails">Etagen: {location.levels}<br />Pos/etage: {location.levelPositions}</div>
</div>

<style>
    .content {
        margin-top: -20px;
        margin-right: 40px;
        cursor: default;
    }

    .contentDetails {
        margin-top: 0px;
        margin-right: 40px;
        cursor: default;
    }

	.box {
	  background: lightgray;
	  padding: 10px;
	  border-radius: 0.8rem;
      margin-bottom: 10px;
	  display: flex;
	  flex-direction: column;
	}
    
    .icons {
        align-self: flex-end;
        display: inline-flex;
        justify-content: space-between;
    }

</style>